/** Used for requests to one of our own node-endpoints. For back-end calls, use "use(Client/Server)SideRequestObject" instead */
export const wrapNodeRequest = async <T = unknown>(
    url: string,
    method: RequestMethods,
    options?: RequestInit,
): Promise<T> => {
    const response = await fetch(url, {
        ...options,
        method,
    })

    const result: T = await response.json()

    return result
}

export type RequestMethods = 'GET' | 'POST' | 'PUT' | 'DELETE'
